import { useI18n } from "../lib/i18n";

export function LanguageSwitch() {
  const { locale, setLocale, t } = useI18n();
  return (
    <button
      className="language-switch"
      type="button"
      onClick={() => setLocale(locale === "zh-CN" ? "en" : "zh-CN")}
      aria-label={locale === "zh-CN" ? "Switch to English" : "切换到简体中文"}
    >
      <span aria-hidden="true">文</span>
      {locale === "zh-CN" ? t("english") : t("chinese")}
    </button>
  );
}
